import React, { useEffect, useState } from 'react';
import AIChat from './AIChat';
import './AIChatButton.css';

const AIChatButton = ({ userContext = {} }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const open = () => setIsChatOpen(true);
    window.addEventListener('occasia:open-help', open);
    return () => window.removeEventListener('occasia:open-help', open);
  }, []);

  const handleOpenChat = () => {
    setIsChatOpen(true);
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
  };

  return (
    <>
      {/* Floating AI Chat Button */}
      <button 
        className="ai-chat-fab"
        onClick={handleOpenChat}
        title="Ask Occasia AI for help"
        aria-label="Open AI Chat Assistant"
      >
        <img src="/icons/ask-help-white.png" alt="" width="32" height="32" />
      </button>

      {/* AI Chat Modal */}
      <AIChat 
        isOpen={isChatOpen}
        onClose={handleCloseChat}
        userContext={userContext}
      />
    </>
  );
};

export default AIChatButton;
